import { useLocation } from '@tanstack/react-router';

import { useGoHome } from '@libs/hooks/useGoHome';
import { ErrorsNotificationProvider } from '@providers/ErrorsNotificationProvider';
import { ThemeLink } from '@ui/components/ThemeLink';

import { SiteLayoutWidget } from '@features/shared/ui/SiteLayout/SiteLayoutWidget';

import styles from './ErrorPage.module.css';

type Props = {
  title?: string;
  subTitle?: string;
};
export function ErrorPage({ title = ':(', subTitle = 'Что-то пошло не так' }: Props) {
  const location = useLocation();
  const isClubRootPage = location.pathname.match('/club/([^/]+)$');
  const goHome = useGoHome({ preserveClub: !isClubRootPage });

  const clubId = location.pathname.match('/club/([^/]+)/')?.[1];

  return (
    <ErrorsNotificationProvider>
      <SiteLayoutWidget clubId={clubId || ''}>
        <div className={styles.content}>
          <div className={styles.header}>{title}</div>
          <div className={styles.subTitle}>{subTitle}</div>
          <div className={styles.links}>
            <ThemeLink onClick={() => window.location.reload()}>Обновить страницу</ThemeLink>
            <ThemeLink onClick={goHome}>На главную</ThemeLink>
          </div>
        </div>
      </SiteLayoutWidget>
    </ErrorsNotificationProvider>
  );
}
